export default "__VITE_ASSET__b483ff13__"